import { Injectable } from '@angular/core';
import { CometChat } from './cometchat-sdk';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class CometChatInitService {

  private initialized = false;

  async init(): Promise<void> {
    if (this.initialized) return;

    const appSetting = new CometChat.AppSettingsBuilder()
      .subscribePresenceForAllUsers()
      .setRegion(environment.cometchat.region)
      .build();

    await CometChat.init(environment.cometchat.appId, appSetting);
    this.initialized = true;
  }
}
